/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SoftwareRequirement } from "./SoftwareRequirement";
import {
  SoftwareRequirementFromJSON,
  SoftwareRequirementFromJSONTyped,
  SoftwareRequirementToJSON,
  SoftwareRequirementToJSONTyped,
} from "./SoftwareRequirement";

/**
 *
 * @export
 * @interface CreateSoftwareBody
 */
export interface CreateSoftwareBody {
  /**
   *
   * @type {string}
   * @memberof CreateSoftwareBody
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateSoftwareBody
   */
  description?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateSoftwareBody
   */
  url?: string | null;
  /**
   *
   * @type {string}
   * @memberof CreateSoftwareBody
   */
  iconSlug?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof CreateSoftwareBody
   */
  managedInEntra: boolean;
  /**
   *
   * @type {string}
   * @memberof CreateSoftwareBody
   */
  managementUrl?: string | null;
  /**
   *
   * @type {SoftwareRequirement}
   * @memberof CreateSoftwareBody
   */
  requirement: SoftwareRequirement;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateSoftwareBody
   */
  requiredTeamIds: Array<string>;
}

/**
 * Check if a given object implements the CreateSoftwareBody interface.
 */
export function instanceOfCreateSoftwareBody(
  value: object,
): value is CreateSoftwareBody {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("managedInEntra" in value) || value["managedInEntra"] === undefined)
    return false;
  if (!("requirement" in value) || value["requirement"] === undefined)
    return false;
  if (!("requiredTeamIds" in value) || value["requiredTeamIds"] === undefined)
    return false;
  return true;
}

export function CreateSoftwareBodyFromJSON(json: any): CreateSoftwareBody {
  return CreateSoftwareBodyFromJSONTyped(json, false);
}

export function CreateSoftwareBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreateSoftwareBody {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    description: json["description"] == null ? undefined : json["description"],
    url: json["url"] == null ? undefined : json["url"],
    iconSlug: json["iconSlug"] == null ? undefined : json["iconSlug"],
    managedInEntra: json["managedInEntra"],
    managementUrl:
      json["managementUrl"] == null ? undefined : json["managementUrl"],
    requirement: SoftwareRequirementFromJSON(json["requirement"]),
    requiredTeamIds: json["requiredTeamIds"],
  };
}

export function CreateSoftwareBodyToJSON(json: any): CreateSoftwareBody {
  return CreateSoftwareBodyToJSONTyped(json, false);
}

export function CreateSoftwareBodyToJSONTyped(
  value?: CreateSoftwareBody | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    description: value["description"],
    url: value["url"],
    iconSlug: value["iconSlug"],
    managedInEntra: value["managedInEntra"],
    managementUrl: value["managementUrl"],
    requirement: SoftwareRequirementToJSON(value["requirement"]),
    requiredTeamIds: value["requiredTeamIds"],
  };
}
